import Vue from 'vue';

export const eventBus = new Vue({
  methods: {
    menuDataChanged: function (itemKey) {
      this.$emit('menu-data-changed', itemKey);
    },
    refreshMenuData: function (data) {
      this.$emit('refresh-menu-data', data);
    },
    selectedCategory: function (item, index) {
      console.log('EVENT selectedCategory:', item, index);
      this.$emit('selected-category', item, index);
    },

    selectedTreatment: function (treatment) {
      this.$emit('selected-treatment', treatment);
    },
    selectedDateTime: function (date, localTime) {
      var selectedDate = null;
      console.log("event selectedDateTime:", date);
      if (date)
        selectedDate = date.toISOString();
      this.$emit('selected-date-time', selectedDate, localTime);
      console.log("Event selectedDateTime", selectedDate, localTime);
    },
    reserveDate: function () {
      this.$emit('reserve-date');
    },
    bookNow: function () {
      this.$emit('book-now');
    },
    contactDetailsValid: function (clientDetails) {
      this.$emit('contact-details-valid', clientDetails);
    },
    contactDetailsInvalid: function (clientDetails) {
      this.$emit('contact-details-invalid', clientDetails);
    },
    loginEmailValid: function (value) {
      this.$emit('login-email-valid', value);
    },
    submitLoginForm: function (isDemo) {
      this.$emit('submit-login-form', isDemo);
    },
    closeBookingDialog: function () {
      this.$emit('close-booking-dialog');

    },
    showBookingDialog: function () {
      this.$emit('show-booking-dialog');

    },
    updateDialogTitle: function (title, subtitle) {
      this.$emit('update-dialog-title', title, subtitle);
    },
    switchToAdminView: function () {
      this.$emit("switch-to-admin-view");
    },
    isLoginView: function (value) {
      this.$emit("is-login-view", value);
    },
    adminTabChanged: function (tab, data) {
      this.$emit('admin-tab-changed', tab, data);
    },

    selectAdminMenuOption: function (option, data) {
      console.log("sending data", data);
      this.$emit('select-admin-menu-option', option, data);
    },
    openCloseAdminRightDrawer: function (isOpen) {
      this.$emit('open-close-admin-right-drawer', isOpen);

    },
    onAddAppointmentClick: function () {
      this.$emit("add-appointment-click");
    },
    onUpdateAppointmentClick: function (isDeleted) {
      this.$emit("update-appointment-click", isDeleted);
    },
    addAppointmentFormValidation: function (isValid) {
      this.$emit("add-appointment-form-validation", isValid);
    },
    addTreatmentFormValidation: function (isValid) {
      this.$emit("add-treatment-form-validation", isValid);
    },
    newAppointmentCreated: function (id) {
      this.$emit("new-appointment-created", id);
    },
    appointmentUpdated: function (id) {
      this.$emit("appointment-updated", id);
    },
    newTreatmentCreated: function (id) {
      this.$emit("new-treatment-created", id);
    },
    onAddTreatmentClick: function () {
      this.$emit("add-treatment-click");
    },
    userSignedIn: function (user, claims) {
      this.$emit("user-signed-in", user, claims);
      console.log("Event fired: user-signed-in", user, claims);
    },
    userSignedOut: function (user) {
      this.$emit("user-signed-out", user);
      console.log("Event fired: user-signed-out");
    },
    newSnackbar: function (info, actionType) {
      this.$emit('new-snack-bar', info, actionType);
      console.log("Event fired: new-snack-bar.", info, actionType);
    },
    magicLinkSent: function () {
      this.$emit('magic-link-sent');
    },
    openCloseLeftSidemenu: function (open) {
      this.$emit('open-close-left-sidemenu', open);
    },
    showDefaultCategories: function (show) {
      this.$emit('show-default-categories', show);
    }
  }
})